import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { ModalOpenerService } from 'src/app/services/modal-opener.service';
import { workItemsQaGenericReportOpener } from '../work-items-qa-generic-report/work-items-qa-generic-report.modal';

@Component({
  selector: 'app-work-items-qa-generic-entry',
  templateUrl: './work-items-qa-generic-entry.component.html',
  styleUrl: './work-items-qa-generic-entry.component.scss'
})
export class WorkItemsQaGenericEntryComponent implements OnInit {
  private readonly modalOpener = inject(ModalOpenerService);
  private loaderService$ = inject(LoaderService);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    const genericQaHyperlink =
      this.route?.snapshot?.queryParams?.genericQaHyperlink;

    if (!genericQaHyperlink) {
      return;
    }

    this.modalOpener.open(workItemsQaGenericReportOpener);

    this.loaderService$.hide();
  }

  onEntryButtonClick(): void {
    this.modalOpener.open(workItemsQaGenericReportOpener);
  }
}
